<template>
	<div :class="['transfer-card', msgInfo.selfSend ? 'mine' : '']" @click="onClick">
		<div class="card">
			<!-- 左侧转账图标 -->
			<div class="transfer-icon">
				<div class="icon-wrapper">
					<i class="el-icon-bank-card"></i>
				</div>
			</div>

			<!-- 右侧内容 -->
			<div class="content">
				<div class="title-row">
					<span class="title">转账</span>
					<span class="amount" v-if="transferInfo">¥{{ transferInfo.amount }}</span>
				</div>
				<div class="remark-row" v-if="transferInfo && transferInfo.remark">
					<span class="remark">{{ transferInfo.remark }}</span>
				</div>
				<div class="status-row">
					<span class="status">{{ statusText }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TransferCard",
	props: {
		msgInfo: {
			type: Object,
			required: true
		},
		currentUserId: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			transferInfo: null,
			loading: true
		}
	},
	computed: {
		isSender() {
			return this.msgInfo.sendId === this.currentUserId;
		},
		statusText() {
			if (!this.transferInfo) {
				return this.isSender ? '等待对方领取' : '待领取';
			}

			const status = this.transferInfo.status;

			if (this.isSender) {
				switch (status) {
					case 1: return '等待对方领取';
					case 2: return '对方已收款';
					case 3: return '已过期退款';
					case 4: return '已退款';
					default: return '查看详情';
				}
			} else {
				switch (status) {
					case 1: return '待领取';
					case 2: return '已收款';
					case 3: return '已过期';
					case 4: return '已退款';
					default: return '查看详情';
				}
			}
		}
	},
	methods: {
		onClick() {
			// 触发父组件的点击事件
			this.$emit('click', this.msgInfo);
		},
		async loadTransferDetail() {
			try {
				this.loading = true;
				const transferNo = this.msgInfo.content;

				// 调用转账详情API
				const res = await this.$http({
					url: `/transfer/detail/${transferNo}`,
					method: 'GET'
				});

				this.transferInfo = res.data || res;
			} catch (error) {
				console.error('获取转账详情失败:', error);
				// 降级方案
				this.transferInfo = {
					transferNo: this.msgInfo.content,
					amount: 0,
					remark: '',
					status: 1
				};
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		// 挂载时加载转账详情
		// this.loadTransferDetail();
	}
}
</script>

<style lang="scss" scoped>
.transfer-card {
	display: inline-block;
	min-width: 260px;
	max-width: 320px;
	background: linear-gradient(135deg, #fff 0%, #fafafa 100%);
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	padding: 16px 20px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	cursor: pointer;
	transition: all 0.2s ease;
	user-select: none;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
		border-color: #ff9800;
	}

	&:active {
		transform: translateY(0);
	}

	&.mine {
		background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
		border-color: #ffb74d;
	}

	.card {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	/* 转账图标 */
	.transfer-icon {
		flex-shrink: 0;
	}

	.icon-wrapper {
		width: 50px;
		height: 50px;
		background: linear-gradient(135deg, #ff9800 0%, #ffa726 100%);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);

		i {
			font-size: 24px;
			color: white;
		}
	}

	/* 右侧内容 */
	.content {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.title-row {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
			font-size: 15px;
			font-weight: 600;
			color: #333;
		}

		.amount {
			font-size: 16px;
			font-weight: 700;
			color: #ff9800;
		}
	}

	.remark-row {
		.remark {
			font-size: 13px;
			color: #666;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			display: block;
		}
	}

	.status-row {
		.status {
			font-size: 12px;
			color: #999;
		}
	}
}
</style>

